/*
 * @Description: iscroll初始化
 * @Author: 康蔚明
 * @LastEditors: 康蔚明
 * @Date: 2020-05-21 11:19:36
 * @LastEditTime: 2020-05-21 11:27:13
 */ 
import IScroll from 'iscroll/build/iscroll';

window.IScroll = IScroll;